import { FC } from "react";
import { DeviceIcon } from "shared/ui/icons/deviceIcon";
import {
    HiveDeviceContainer,
    HiveDeviceIconWrapper,
    HiveDeviceNone,
    HiveDeviceValue
} from "features/hives/ui/hivesTable/styles.ts";

type Props = {
    count: number | null | undefined;
};

export const HiveDeviceCell: FC<Props> = ({ count }) => {
    const devices = Number(count) || 0;

    return (
        <HiveDeviceContainer>
            {devices > 0 ? (
                <>
                    <HiveDeviceIconWrapper>
                        <DeviceIcon />
                    </HiveDeviceIconWrapper>
                    <HiveDeviceValue>{devices}</HiveDeviceValue>
                </>
            ) : (
                <HiveDeviceNone>–</HiveDeviceNone>
            )}
        </HiveDeviceContainer>
    );
};